import React from "react";
import _ from "lodash";

import Table from "components/Table";
import { deliveryLinesColumns } from "./columns";

interface IProps {
  isLoading: boolean;
  loadData: () => void;
  data: any[];
}

class DeliveryLines extends React.PureComponent<IProps> {
  public componentDidMount() {
    this.props.loadData();
  }

  public render() {
    const { data, isLoading } = this.props;

    return (
      <Table
        columns={deliveryLinesColumns}
        dataSource={data}
        isLoading={isLoading}
      />
    );
  }
}

export default DeliveryLines;
